/**
 * Extract a human-readable message from a $fetch/ofetch error.
 *
 * The server sets `message` via h3's createError(), which ofetch puts on
 * `err.data.message`. `err.message` itself is the unhelpful "[POST] /api/x: 4xx".
 */
export function extractFetchErrorMessage(err: unknown, fallback: string): string {
  if (err && typeof err === 'object') {
    const fetchErr = err as { data?: { message?: string, statusMessage?: string }, statusMessage?: string, message?: string }
    if (fetchErr.data?.message) return fetchErr.data.message
    if (fetchErr.data?.statusMessage) return fetchErr.data.statusMessage
    if (fetchErr.statusMessage) return fetchErr.statusMessage
    if (fetchErr.message) return fetchErr.message
  }
  return fallback
}
